package com.eladfinish.bible.contest.screens.main.verseWidgetSheet

import com.eladfinish.bible.contest.repository.remoteConfig.RemoteConfig
import com.eladfinish.bible.contest.repository.remoteConfig.RemoteConfigRepository
import com.eladfinish.bible.contest.screens.main.featureSheet.OneTimeSheetGate
import com.russhwolf.settings.Settings

/**
 * Who sees the one-time "what's new" sheet that introduces the "ווידג'ט פסוק מתחלף" tile
 * ([com.eladfinish.bible.contest.screens.main.data.ButtonType.VERSE_WIDGET]): users who had the
 * app before the version with the widget, once, on Android and iOS (the widget exists nowhere else).
 */
class VerseWidgetSheetGate(
    settings: Settings,
    remoteConfigRepository: RemoteConfigRepository,
    isSupportedPlatform: Boolean,
) : OneTimeSheetGate(
    settings = settings,
    remoteConfigRepository = remoteConfigRepository,
    isSupportedPlatform = isSupportedPlatform,
    existingUserKey = KEY_EXISTING_USER,
    shownKey = KEY_SHOWN,
    switchesThatMustBeOff = listOf(RemoteConfig.DISABLE_VERSE_WIDGET, RemoteConfig.DISABLE_VERSE_WIDGET_SHEET),
) {
    companion object {
        const val KEY_EXISTING_USER = "verse_widget_sheet_existing_user"
        const val KEY_SHOWN = "verse_widget_sheet_shown"
    }
}
